export const featuredNews = {
  category: "新番观察",
  date: "10 月 09 日",
  title: "当季新番进入中盘：高开低走与后程发力的分水岭",
  summary:
    "随着多数作品播出过半，剧情节奏与作画稳定性成为拉开差距的关键。本文梳理本季几部重点作品的走势，并给出下半程的追番建议，帮助你在有限时间里挑选更值得跟进的作品。",
  image:
    "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cozy%20viewing%20room%20with%20a%20large%20screen%20glowing%20warm%20coral%20light%2C%20scattered%20posters%20and%20snacks%20on%20a%20low%20table%2C%20stylized%20flat%20anime%20art%20style%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20evening%20atmosphere%2C%20consistent%20art%20direction%2C%20simple%20clean%20background&width=1200&height=720&seq=anime-news-feature&orientation=landscape",
  alt: "温馨观影室中追番的动漫风格插画",
};

export const newsList = [
  {
    category: "业界动态",
    date: "10 月 08 日",
    title: "制作委员会模式下的排期变化，如何影响一部番的作画质量",
    summary:
      "排期与人力分配往往是决定观感的关键变量，本文用通俗的方式解释制作流程中的时间节点。",
  },
  {
    category: "榜单速递",
    date: "10 月 07 日",
    title: "本周评分榜出炉：治愈系与音乐题材集体上扬",
    summary:
      "长尾口碑作品在中期普遍走高，慢热型内容更容易在完整播出后收获高评价。",
  },
  {
    category: "新番前瞻",
    date: "10 月 05 日",
    title: "下季候补名单一览：续作与改编作品分布",
    summary:
      "多部续作集中定档，改编赛道继续升温。本文按题材整理值得关注的候补作品。",
  },
  {
    category: "追番技巧",
    date: "10 月 03 日",
    title: "三集定律还成立吗？关于试看与弃番的实用判断",
    summary:
      "结合节奏、演出与题材偏好，给出一套更省时间的试看方法，减少追到一半弃番的遗憾。",
  },
];